const STATUS_CONFIG = {
  pending: { label: "جديد", color: "bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300", dot: "bg-amber-500" },
  assigned: { label: "مُعيَّن", color: "bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300", dot: "bg-blue-500" },
  picked_up: { label: "تم الاستلام", color: "bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300", dot: "bg-purple-500" },
  sorting: { label: "فرز", color: "bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-300", dot: "bg-orange-500" },
  processing: { label: "تنظيف", color: "bg-cyan-100 text-cyan-700 dark:bg-cyan-900/30 dark:text-cyan-300", dot: "bg-cyan-500" },
  ready: { label: "جاهز", color: "bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300", dot: "bg-green-500" },
  delivering: { label: "توصيل", color: "bg-indigo-100 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-300", dot: "bg-indigo-500" },
  delivered: { label: "مُسلَّم", color: "bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400", dot: "bg-gray-400" },
  cancelled: { label: "ملغي", color: "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300", dot: "bg-red-500" },
};

export default function OrderCard({ order, onClick }) {
  const cfg = STATUS_CONFIG[order.status] || STATUS_CONFIG.pending;
  const date = new Date(order.created_date).toLocaleDateString("ar-SA", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });

  return (
    <button
      onClick={onClick}
      className="w-full bg-card rounded-2xl p-4 border border-border shadow-sm hover:shadow-md hover:border-cyan-300 dark:hover:border-cyan-700 transition-all text-right"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <span className="font-black text-foreground text-sm">{order.customer_name}</span>
            {order.status === "pending" && (
              <span className="w-1.5 h-1.5 bg-amber-500 rounded-full animate-pulse" />
            )}
          </div>
          <p className="text-xs text-muted-foreground mb-1">{order.customer_phone}</p>
          <p className="text-xs text-muted-foreground truncate">📍 {order.customer_address}{order.district ? ` — ${order.district}` : ""}</p>
          {order.delegate_name && (
            <p className="text-xs text-blue-600 dark:text-blue-400 mt-1">👤 {order.delegate_name}</p>
          )}
        </div>
        <div className="flex flex-col items-end gap-2 flex-shrink-0">
          <span className={`text-xs font-bold px-2.5 py-1 rounded-full ${cfg.color}`}>
            {cfg.label}
          </span>
          <span className="font-black text-cyan-600 dark:text-cyan-400 text-sm">
            {order.order_number}
          </span>
          {order.total_amount > 0 && (
            <span className="text-xs font-bold text-gray-700 dark:text-gray-300">{order.total_amount} ر.س</span>
          )}
        </div>
      </div>
      <div className="flex items-center justify-between mt-2 pt-2 border-t border-border">
        <span className="text-xs text-muted-foreground">{date}</span>
        {order.invoice_sent && <span className="text-xs text-green-600 dark:text-green-400">📧 الفاتورة أُرسلت</span>}
        {order.paid && <span className="text-xs text-green-600 dark:text-green-400">✅ مدفوع</span>}
      </div>
    </button>
  );
}